module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/pictogram-skyscrapers-719edddada7ed36b1f10ec4184c7ba41.svg";